export function GeneralSettingsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.GENERAL_SETTINGS + '/:action')
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
            'updateXrayUrl': {
                method: 'POST',
                params: {action: 'xrayUrl'}
            },
            'getSystemParams': {
                method: 'GET',
                path: '/configuration/systemParameters'
            },
            'setSystemParams': {
                method: 'PUT',
                path: '/configuration/systemParameters'
            },
            'getSystemParamsNoLic': {
                method: 'GET',
                path: '/configuration/systemParametersNoLic'
            },
            'setSystemParamsNoLice': {
                method: 'PUT',
                path: '/configuration/systemParametersNoLic'
            },
            'getHttpsInfo': {
                method: 'GET',
                path: '/httpSettings'
            },
            'updateHttpsInfo': {
                method: 'PUT',
                path: '/httpSettings',
                notifications: true
            },
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/general_settings_dao.js